import React from 'react';
import AppNav from '@/components/AppNav';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';
import ViolationWizard from '@/components/ViolationWizard';

const PublicViolationWizardPage = () => {
  return (
    <div className="min-h-screen bg-[#FBF7F0]" data-testid="public-violation-wizard-page">
      <SEO
        title="Free TikTok Shop Violation Appeal Tool | Poettik"
        description="Got a TikTok Shop violation? Use Poettik's free appeal tool for an honest assessment, your estimated success chance, and a ready-to-copy appeal, plus how similar appeals have gone for other creators. No account needed."
      />
      <nav className="relative z-50 border-b border-border bg-card">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center h-16">
            <AppNav />
          </div>
        </div>
      </nav>

      <main className="relative z-0">
        <ViolationWizard mode="public" />
      </main>

      <Footer />
    </div>
  );
};

export default PublicViolationWizardPage;
